<template lang="pug">
.form-article-default.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.articleDefault" autocomplete="ño" :disabled="true" required)
        label.label(:class="{ show: dataForm.articleDefault }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="articleDefault" title="Nombre Artículo Predeterminado")

      .input-container
        select.select(v-model="dataForm.article" autocomplete="ño" @change="updateArticleDefaultName" :disabled="fillData" required)
          option(v-for="article in articles" :value="article.article") {{ article.article }}
        label.label(:class="{ show: dataForm.article }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="article" title="Artículo")

      .input-container
        select.select(v-model="dataForm.person" autocomplete="ño" @change="updateArticleDefaultName" :disabled="fillData" required)
          option(v-for="person in persons" :value="person.person") {{ person.person }}
        label.label(:class="{ show: dataForm.person }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="person" title="Persona")

      .input-container
        select.select(v-model="dataForm.design" autocomplete="ño" @change="updateArticleDefaultName" :disabled="fillData" required)
          option(v-for="design in designs" :value="design") {{ design }}
        label.label(:class="{ show: dataForm.design }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="design" title="Diseño")

    .divider

    .form-section
      .input-container
        input.input(v-model.number="dataForm.priceUnit"  type="number" min="0" max="1000000" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.priceUnit >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceUnit" title="Precio Unitario")

      .input-container
        input.input(v-model.number="dataForm.priceWholesaler"  type="number" min="0" max="1000000" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.priceWholesaler >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceWholesaler" title="Precio Mayorista")

      .input-container
        input.input(v-model.number="dataForm.priceSale"  type="number" min="0" max="1000000" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.priceSale >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="priceSale" title="Precio Promoción")

    .divider

    .form-section
      .input-container
        input.input(v-model.number="dataForm.cost"  type="number" min="0" max="1000000" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.cost >= 0 }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="cost" title="Costo")

    .divider

    .form-section
      .input-container
        input.input(v-model.number="dataForm.order"  type="number" autocomplete="ño" required)
        label.label(:class="{ show: Number.isInteger(dataForm.order) }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Order")

    .divider

    .left
      .sub-title Palabras Claves

    .form-section
      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="" property="keywords" :line="true")

    .divider

    .form-section
      shUploadImage(@uploaded="addImage" url="img/measures")

    .divider

    h3 Imágenes de Medidas

    TransitionGroup.images-measure-container(name="slide-fade")
      div(v-for="(image, index) in dataForm.imagesMeasure" :key="image")
        .buttons-image
          shActionButton(v-if="index" :action="toLeft" :params="[index]" text="<" textRunning="<" :mini="true")
          shActionButton(v-if="dataForm.imagesMeasure.length - 1 !== index" :action="toRight" :params="[index]" text=">" textRunning=">" :mini="true")
          shActionButton(:action="deleteImage" :params="[index]" text="x" textRunning="x" :mini="true" :warning="true")
        .buttons-image
          shActionButton(v-if="index" :action="toLeft" :params="[index, true]" text="< texto" textRunning="<" :mini="true")
          shActionButton(v-if="dataForm.imagesMeasure.length - 1 !== index" :action="toRight" :params="[index, true]" text="texto >" textRunning=">" :mini="true")
        shDimensionsLines(:src="`https://sahet-cdn.b-cdn.net/img/measures/${image}`" @updateText="(texts) => { saveText(index, texts) }" :texts="dataForm.texts[index]")

    shActionButton(:isForm="true" :text="fillData ? 'Guardar Cambios' : 'Guardar'" :textRunning="fillData ? 'Guardando Cambios' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteArticleDefault")

  div
    h3 Actualizar

    .container-actions-product
      shActionButton(:action="updateProducts" :params="[true, false, false, false]" text="Precios" textRunning="Actualizando" :mini="true" :textConfirmation="`Se actualizarán los precios de todos los productos con las siguiente características: Artículo: ${dataForm.article}, Persona: ${dataForm.person}, Diseño: ${dataForm.design}`")
      shActionButton(:action="updateProducts" :params="[false, false, false, true]" text="Costos" textRunning="Actualizando" :mini="true" :textConfirmation="`Se actualizarán los costos de los productos Sahet con las siguiente características: Artículo: ${dataForm.article}, Persona: ${dataForm.person}, Diseño: ${dataForm.design}`")
      shActionButton(:action="updateProducts" :params="[false, true, false, false]" text="Imágenes" textRunning="Actualizando" :mini="true" :textConfirmation="`Se actualizarán las imágenes de todos los productos con las siguiente características: Artículo: ${dataForm.article}, Persona: ${dataForm.person}, Diseño: ${dataForm.design}`")
      shActionButton(:action="updateProducts" :params="[false, false, true, false]" text="Palabras Claves" textRunning="Actualizando" :mini="true" :textConfirmation="`Se actualizarán las palabras claves de todos los productos con las siguiente características: Artículo: ${dataForm.article}, Persona: ${dataForm.person}, Diseño: ${dataForm.design}`")

  div(v-if="productsUpdated.length")
    h3 Productos Actualizados
    div {{ productsUpdated }}

  div(v-if="errors.length")
    h3 Errores
    div {{ errors }}
</template>

<script>
import mForm from '@/mixins/form'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlArticleDefault from '@/graphql/articleDefault'
import shSelectList from '@/components/elements/SelectList'
import shInputList from '@/components/elements/InputList'
import shUploadImage from '@/components/pages/image/FormUpload'
import shDimensionsLines from '@/components/elements/DimensionLines.vue'
import modals from '@my/store/modals'

export default {
  name: 'FormArticleDefault',

  mixins: [mForm, mDB],

  components: { shSelectList, shInputList, shUploadImage, shDimensionsLines },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        articleDefault: '',
        article: '',
        person: '',
        design: '',
        priceUnit: '',
        priceWholesaler: '',
        priceSale: '',
        order: 0,
        imagesMeasure: [],
        texts: [],
        keywords: [''],
        cost: 0
      },
      resolver: 'articleDefault',
      key: 'articleDefault',
      gql: gqlArticleDefault,
      errors: [],
      productsUpdated: [],
      delete: ['createdAt', 'updatedAt']
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
    if (this.dataForm.keywords.length === 0) this.dataForm.keywords.push('')
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newArticleDefault()
      } else {
        this.updateArticleDefault()
      }
    },

    newArticleDefault () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateArticleDefault () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteArticleDefault () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    updateArticleDefaultName () {
      if (!this.dataForm.person || !this.dataForm.article || !this.dataForm.design) {
        this.dataForm.articleDefault = ''
      } else {
        this.dataForm.articleDefault = `${this.dataForm.article}-${this.dataForm.person}-${this.dataForm.design}`
      }
    },
    addImage (name) {
      const index = this.dataForm.imagesMeasure.findIndex(imageName => imageName === name)
      if (index >= 0) {
        this.dataForm.imagesMeasure.splice(index, 1)
        // this.dataForm.texts.splice(index, 1)
      }

      this.dataForm.imagesMeasure.push(name)
      this.dataForm.texts.push('')
    },

    deleteImage (index) {
      this.dataForm.imagesMeasure.splice(index, 1)
      this.dataForm.texts.splice(index, 1)
    },

    toLeft (index, onlyText) {
      if (!index) return

      const image = this.dataForm.imagesMeasure[index]
      const text = this.dataForm.texts[index]

      if (!onlyText) this.dataForm.imagesMeasure.splice(index, 1)
      if (!onlyText) this.dataForm.imagesMeasure.splice(index - 1, 0, image)

      this.dataForm.texts.splice(index, 1)
      this.dataForm.texts.splice(index - 1, 0, text)
    },

    toRight (index, onlyText) {
      if ((this.dataForm.imagesMeasure.length - 1) === index) return

      const image = this.dataForm.imagesMeasure[index]
      const text = this.dataForm.texts[index]

      if (!onlyText) this.dataForm.imagesMeasure.splice(index, 1)
      if (!onlyText) this.dataForm.imagesMeasure.splice(index + 1, 0, image)

      this.dataForm.texts.splice(index, 1)
      this.dataForm.texts.splice(index + 1, 0, text)
    },

    saveText (index, texts) {
      this.dataForm.texts[index] = JSON.stringify(texts)
    },

    async updateProducts (updatePrices, updateImages, updateKeywords, updateCosts) {
      const { article, person, design } = this.dataForm

      if (!article) {
        modals.showMessage({ message: 'Este Artículo Predeterminado no tiene Artículo', type: 'error' })
        return
      }

      if (!person) {
        modals.showMessage({ message: 'Este Artículo Predeterminado no tiene Persona', type: 'error' })
        return
      }

      if (!design) {
        modals.showMessage({ message: 'Este Artículo Predeterminado no tiene Diseño', type: 'error' })
        return
      }

      this.productsUpdated = []
      this.errors = []

      const query = gqlArticleDefault.UPDATE_PRODUCTS
      const options = { article, person, design, updateImages, updatePrices, updateCosts, updateKeywords }

      const response = await gql.query(query, options, false)

      if (!response) {
        modals.showMessage({ message: 'No se pudo conectar al servidor', type: 'error' })
      } else {
        if (response.data && !response.data.updateProductsDefault) {
          modals.showMessage({ message: 'Error desconocido al intentar actualizar los products', type: 'error' })
        } else {
          const { productsUpdated, errors } = response.data.updateProductsDefault
          this.productsUpdated = productsUpdated
          this.errors = errors
          modals.showMessage({ message: `Productos actualizados correctamente. Cantidad actualizados (${productsUpdated.length})` })
        }
      }
    }
  },

  computed: {
    persons () {
      return this.$store.state.persons
    },
    articles () {
      return this.$store.state.variables.articles
    },
    designs () {
      return this.$store.state.variables.designs
    },
    sizes () {
      return this.$store.state.variables.sizes
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-article-default
  position relative

.images-measure-container
  display flex
  justify-content center
  flex-wrap wrap

.images-measure-container > div
  width 40em

.buttons-image
  display flex
  gap 1em
  justify-content center
  margin-bottom 1em

.container-actions-product
  display inline-flex
  gap 1em
  flex-wrap wrap
</style>



// WEBPACK FOOTER //
// src/components/pages/articleDefault/Form.vue